import type { SlotName } from 'src/types/Cury';

type FormatFn = (key: string, options?: { default?: string; values?: Record<string, string> }) => string;

export const getSlotVialName = (
	slots: Record<string, { vial?: { name?: string } }> | undefined,
	slot: SlotName,
): string | undefined => slots?.[slot]?.vial?.name;

export const parseVialFaultNotification = (
	notification: string,
): { slot: SlotName; fault: string } | null => {
	const match = notification.match(/^vial_fault_(left|right)_(.+)$/);
	if (!match) {
		return null;
	}

	return { slot: match[1] as SlotName, fault: match[2] };
};

export const formatEmptyVialMessage = (
	vialName: string | undefined,
	format: FormatFn,
	namedKey: string,
	namedDefault: string,
	fallbackKey: string,
	fallbackDefault: string,
): string => {
	if (vialName) {
		return format(namedKey, {
			default: namedDefault,
			values: { vialName },
		});
	}

	return format(fallbackKey, { default: fallbackDefault });
};
